module.exports = __webpack_public_path__ + "static/media/1019431.b4b0c36d.jpg";